import router, { constantRoutes, dynamicRoutes } from '@/router'
import { getMessagePage, markMessageRead } from '@/api/system/notice'

const permission = {
  state: {
    routers: [],
    addRouters: [],
    sidebarRouters: [],
    // 通知消息
    navbarNoticeCount: 0
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRoutes.concat(routers)
    },
    SET_SIDEBAR_ROUTERS: (state, routes) => {
      state.sidebarRouters = routes
    },

    /**
     * 设置菜单 Badge 标记
     * @param {*} payload { parentName, childName, count }
     */
    SET_PERMISSION_MENUS_BADGE: (state, payload) => {
      try {
        const parentObj = state.sidebarRouters.find(item => item.meta && item.meta.title === payload.parentName)
        if (parentObj && parentObj.children && parentObj.children.length) {
          const targetChild = parentObj.children.find(item => item.meta && item.meta.title === payload.childName)
          if (targetChild) {
            targetChild.badgeValue = payload.count
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 设置通知消息数量
    SET_NAVBAR_NOTICE_COUNT: (state, count) => {
      state.navbarNoticeCount = count
    }
  },
  actions: {
    // 生成路由
    GenerateRoutes({ commit, state }, userData) {
      // console.log('userData', userData)
      return new Promise(resolve => {
        const asyncRoutes = filterDynamicRoutes(dynamicRoutes, userData)
        // router.addRoute(asyncRoutes)
        asyncRoutes.forEach(route => { router.addRoute(route) })
        commit('SET_ROUTERS', asyncRoutes)
        commit('SET_SIDEBAR_ROUTERS', constantRoutes.concat(asyncRoutes))
        resolve([])

        // 向后端请求路由数据
        // ...
        // getRouters().then(res => {
        //   const sdata = JSON.parse(JSON.stringify(res.data))
        //   const rdata = JSON.parse(JSON.stringify(res.data))
        //   const sidebarRoutes = filterAsyncRouter(sdata)
        //   const rewriteRoutes = filterAsyncRouter(rdata, false, true)
        //   const asyncRoutes = filterDynamicRoutes(dynamicRoutes);
        //   rewriteRoutes.push({ path: '*', redirect: '/404', hidden: true })
        //   router.addRoutes(asyncRoutes);
        //   commit('SET_ROUTES', rewriteRoutes)
        //   commit('SET_SIDEBAR_ROUTERS', constantRoutes.concat(sidebarRoutes))
        //   commit('SET_DEFAULT_ROUTES', sidebarRoutes)
        //   commit('SET_TOPBAR_ROUTES', sidebarRoutes)
        //   resolve(rewriteRoutes)
        // })
      })
    },

    // 获取通知消息
    GetNotice({ commit }, listQuery) {
      return new Promise((resolve, reject) => {
        getMessagePage(listQuery).then(res => {
          commit('SET_NAVBAR_NOTICE_COUNT', res.data.total)
          resolve(res.data.rows)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 标记已读
    MarkMessageRead({ dispatch }, msgId) {
      return new Promise((resolve, reject) => {
        markMessageRead(msgId).then(() => {
          dispatch('GetNotice', { readFlag: 0 })
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

/**
 * 对组件地址赋予相对应的组件实例
 * @param asyncRouterMap
 * @param roles
 */
// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap) {
  return asyncRouterMap.filter(route => {
    route.path = route.route
    route.name = route.title
    // 路由配置
    if (route.meta) {
      route.meta = { ...JSON.parse(route.meta), component: route.component }
    } else {
      route.meta = { component: route.component }
    }
    // 组件路径
    if (route.component) {
      // Layout 组件特殊处理
      if (route.component === 'Layout') {
        route.component = loadView('layout')
      } else {
        // 防止数据不存在导致错误
        try {
          route.component = loadView(route.component)
        } catch (e) {
          route.component = loadView('layout')
        }
      }
    }
    if (route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children)
    }
    return true
  })
}

// 动态路由遍历，验证是否具备权限
export function filterDynamicRoutes(routes, userData) {
  // 注销用户审核中 || 兼职未通过审核 , 不显示路由
  if (userData.status === 3 || (['PartHandler'].includes(userData.userRole) && userData.userLevel === 0)) {
    return []
  }

  return routes.filter(route => {
    if (route.roles) {
      return route.roles.includes(userData.userRole)
    } else {
      return true
    }
  }).map(route => {
    if (route.children) {
      route.children = filterDynamicRoutes(route.children, userData)
    }
    return route
  })
}

export const loadView = (view) => {
  return (resolve) => require([`@/views/${view}`], resolve)
}

export default permission
